// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__9_v6S","row":"ProcedureTreatmentSummary_row__24W4C"};